import React, { useState } from 'react'
import Swal from 'sweetalert2'
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import { GrDomain } from "react-icons/gr"

function DemoClass() {
  const modalStyles = {
    position: 'fixed',
    top: 50,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  }

  const modalContentStyles = {
    backgroundColor: '#fff',
    borderRadius: '5px',
    padding: '20px',
    width: '90%',
    maxWidth: '500px',
  }

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleButtonClick = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    domain: '',
  })

  const [nameError, setNameError] = useState('')
  const [emailError, setEmailError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [domainError, setDomainError] = useState('')

  const handleInputChange = (event) => {
    const { name, value } = event.target

    if (name === 'fullName') setNameError(!value || !/^[A-Za-z\s]+$/.test(value) ? 'Invalid name format.' : '')
    if (name === 'email') setEmailError(!value || !/\S+@\S+\.\S+/.test(value) ? 'Invalid email format' : '')
    if (name === 'mobileNo') setPhoneError(!value || !/^\d{10}$/.test(value) ? 'Length should be 10 digits' : '')
    if (name === 'domain') setDomainError(!value ? 'Please select a domain.' : '')

    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    // Final validation check
    if (!formData.domain) {
      setDomainError('Please select a domain.')
      return
    }

    try {
      const response = await fetch("https://formspree.io/f/mrbgbvqo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        Swal.fire({
          title: 'Form Submitted!',
          text: "Our team will review your submission and get back to you within 24 hours.",
          icon: 'success',
        })
        setFormData({
          fullName: '',
          email: '',
          mobileNo: '',
          domain: '',
        })
        handleCloseModal()
      } else {
        throw new Error('Form submission failed')
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  return (
    <>
      <div>
        <div className="counsellor_background py-4 mb-5">
          <div className="container text-center">
            <h2 className="fs-3">Request a Demo Session</h2>
            <button
              className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button"
              onClick={handleButtonClick}
            >
              Click Here
            </button>
          </div>
        </div>
        {isModalOpen && (
          <div style={modalStyles}>
            <div style={modalContentStyles}>
              <form onSubmit={handleSubmit}>
                <div className='text-center'><span className="contact_form_main">Fill The Form</span></div>
                <div className="form-group mt-4">
                  <label htmlFor="fullName">
                    <SlUser size="20px" color="#565add" /> Full Name
                  </label>
                  <input
                    className="form-control shadow-sm mt-2"
                    type="text"
                    id="fullName"
                    name="fullName"
                    placeholder="Your answer"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  {nameError && <div className="text-danger">{nameError}</div>}
                </div>

                <div className="form-group mt-3">
                  <label htmlFor="email">
                    <MdOutlineMailOutline size="20px" color="#565add" /> Email Address
                  </label>
                  <input
                    className="form-control shadow-sm mt-2"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Your answer"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  {emailError && <div className="text-danger">{emailError}</div>}
                </div>

                <div className="form-group mt-3">
                  <label htmlFor="mobileNo">
                    <HiOutlinePhone size="20px" color="#565add" /> Phone Number
                  </label>
                  <input
                    className="form-control shadow-sm mt-2"
                    type="tel"
                    id="mobileNo"
                    name="mobileNo"
                    placeholder="Your answer"
                    value={formData.mobileNo}
                    onChange={handleInputChange}
                    required
                  />
                  {phoneError && <div className="text-danger">{phoneError}</div>}
                </div>

                <div className="form-group mt-3">
                  <label htmlFor="domain" className='text'><GrDomain size="20px" color="#565add" /> Choose Domain</label>
                  <select
                    className='form-control shadow-sm mt-2'
                    id="domain"
                    name="domain"
                    value={formData.domain}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select a Domain...</option>
                    <option value="Machine Learning">Machine Learning (Supervised)</option>
                    <option value="Artificial Intelligence">Artificial Intelligence (ChatBot, NLP)</option>
                    <option value="Web Development">Web Development</option>
                    <option value="Data Science">Data Science</option>
                    <option value="Cyber Security">Cyber Security</option>
                    <option value="Cloud Computing">Cloud Computing</option>
                    <option value="Android App Development">Android App Development</option>
                    <option value="Robotics">Robotics</option>
                    <option value="Autocad">Autocad</option>
                    <option value="Human Resources">Human Resources</option>
                    <option value="Finance">Finance</option>
                    <option value="Business Analytics">Business Analytics</option>
                    <option value="Java">Java</option>
                    <option value="Python">Python</option>
                    <option value="Digital Marketing">Digital Marketing & Marketing</option>
                    <option value="Full Stack Web Development">Full Stack Web Development</option>
                    <option value="Mern Stack">Mern Stack</option>
                    <option value="C, C++ With DSA">C, C++ With DSA</option>
                  </select>
                  {domainError && <div className="text-danger">{domainError}</div>}
                </div>

                <div className="d-flex justify-content-center mt-4">
                  <button type="submit" className="btn btn-primary px-5 py-2">
                    Submit
                  </button>
                  <button onClick={handleCloseModal} className="btn btn-secondary mx-2 px-4 py-2">
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default DemoClass
